class Layout {
	constructor() {
		this.body = document.getElementsByTagName('body');
		this.menuBar = document.getElementsByClassName('js-menu-bar');
		this.menuBarLabel = document.getElementsByClassName('js-menu-bar-label');
		this.navigation = document.querySelector('.js-navigation');
		this.primaryMenuItem = document.querySelectorAll('.navigation-menu-item--primary');
		this.subNavigationMenuItemHeader = document.querySelectorAll('.sub-navigation-item--header');
		this.backBtn = document.querySelectorAll('.js-back');
		this.viewportWidth = window.outerWidth;
		this.loginBtn = document.getElementsByClassName('js-login');
		this.loginSubmitBtn = document.getElementsByClassName('js-submit-login');
		this.richTextTables = document.querySelectorAll('.rich-text table');
		this.headerElement = document.querySelector('.header');
		this.mainElement = document.getElementById('main');
		this.loginDropDown = document.querySelector('.login-dropdown');
		this.loginLabel = document.querySelector('.login-label');
		this.loginClose = document.querySelector('.login-dropdown-close');
		this.anchorNav = document.querySelector('.anchor-nav-wrapper');
		this.specialOffer = document.querySelector('.special-offer');
		this.footerImages = document.querySelectorAll('.footer-programs-item > img');
		this.closeButtons = document.querySelectorAll('.footer-programs-item-enlarged button');
	}

	init() {
		this.bindEvents();
	}

	bindEvents() {
		this.menuBar[0].addEventListener('click', (event) => {
			if (this.navigation.classList.contains('active')) {
				Array.from(document.querySelectorAll('.navigation-menu-item.open')).forEach(
					(el) => el.classList.remove('open')
				);

				Array.from(document.querySelectorAll('.sub-navigation-item.visible')).forEach(
					(el) => el.classList.remove('visible')
				);
			}

			this.body[0].classList.toggle('nav-active');
			this.menuBar[0].classList.toggle('active');
			this.navigation.classList.toggle('active');

			if (this.viewportWidth < 992) {
				if (this.specialOffer.style.display === '' || this.specialOffer.style.display === 'block') {
					this.specialOffer.style.display = 'none';
				}
				else {
					this.specialOffer.style.display = 'block';
					this.specialOffer.classList.remove('is-expanded');
				}

				// Set offset
				this.setOffset();
			}
		}, false);

		// Main Nav toggle
		this.primaryMenuItem.forEach(menuItem => menuItem.addEventListener('click', (event) => {
			if (this.viewportWidth > 992 && this.specialOffer) {
				this.specialOffer.classList.remove('is-expanded');
			}

			let children = Array.from(menuItem.children);

			if (children.length > 1) {
				if (this.viewportWidth > 992) {
					// Desktop
					if (event.target.classList.contains('navigation-menu-item--primary') || event.target.classList.contains('navigation-menu-item--primary-link')) {
						event.preventDefault();

						if (menuItem.classList.contains('open')) {
							menuItem.classList.remove('open');
						}
						else {
							this.primaryMenuItem.forEach((item) => {
								item.classList.remove('open');
							});

							menuItem.classList.toggle('open');
						}
					}
				}
				else if (event.target.classList.contains('navigation-menu-item--primary-link')) {
					event.preventDefault();

					if (menuItem.classList.contains('open')) {
						menuItem.classList.remove('open');
					}
					else {
						this.primaryMenuItem.forEach((item) => {
							item.classList.remove('open');
						});

						menuItem.classList.toggle('open');
					}
				}
            }
		}));

		// Back button for mobile
		if (this.viewportWidth < 992) {
			this.backBtn.forEach(btn => btn.addEventListener('click', (event) => {
				event.preventDefault();

				btn.parentNode.parentNode.classList.remove('open');
			}));
        }

		// Sub Navigation Click for Mobile
		if (this.viewportWidth < 992) {
			this.subNavigationMenuItemHeader.forEach(item => item.addEventListener('click', (event) => {
				let children = Array.from(item.parentNode.children);

				if (children.length > 1 && !item.classList.contains('sub-navigation-item--orphan')) {
					event.preventDefault();

					children.forEach((child) => {
						child.classList.toggle('visible');
					});
				}
			}));
		}

		// Login Drop Down
		document.addEventListener('DOMContentLoaded', () => {
			if (this.viewportWidth > 992 && window.location.pathname === '/') {
				this.loginDropDown.classList.toggle('active');
				this.loginLabel.classList.toggle('active');

				// Set offset
				this.setOffset();
			}
		});

		this.loginBtn[0].addEventListener('click', (event) => {
			let loginDropDown = document.getElementsByClassName('login-dropdown');
			let loginLabel = document.getElementsByClassName('login-label');
			let specialOffer = document.querySelector('.special-offer');

			loginDropDown[0].classList.toggle('active');
			loginLabel[0].classList.toggle('active');

			if (specialOffer !== null) {
				specialOffer.classList.remove('is-expanded');
            }
		});

		this.loginClose.addEventListener('click', (event) => {
			let loginDropDown = document.getElementsByClassName('login-dropdown');
			let loginLabel = document.getElementsByClassName('login-label');
			let specialOffer = document.querySelector('.special-offer');

			loginDropDown[0].classList.toggle('active');
			loginLabel[0].classList.toggle('active');

			if (specialOffer !== null) {
				specialOffer.classList.remove('is-expanded');
			}
		});

		// Submit Login
		this.loginSubmitBtn[0].addEventListener('click', (event) => {
			event.preventDefault();

			if (document.getElementById('username22').value === '') {
				alert('Please enter a User ID to proceed.');
			}
			else {
				document.forms['q2DForm-22'].submit();
            }
		});

		// Wrap orphan mega menu items in column
		const subNavigationWrapper = document.querySelectorAll('.sub-navigation-wrapper');
		subNavigationWrapper.forEach((subNav) => {
			let subNavigationColumn = document.createElement('li');
			subNavigationColumn.classList.add('sub-navigation-column');
			subNavigationColumn.classList.add('sub-navigation-column--orphans');

			let subNavigation = document.createElement('ul');
			subNavigation.classList.add('sub-navigation');

			const orphans = subNav.querySelectorAll('.sub-navigation-item--orphan');

			orphans.forEach((item) => {
				subNavigation.append(item);
			});

			subNavigationColumn.append(subNavigation);
			subNav.append(subNavigationColumn);
		});

		// Wrap tables
		this.richTextTables.forEach((table) => {
			table.classList.add('table');
			
			let responsiveTable = document.createElement('div');
			responsiveTable.classList.add('table-responsive');
			table.parentElement.insertBefore(responsiveTable, table);
			responsiveTable.append(table);
		});

		// Sticky nav
		if (this.viewportWidth > 992) {
			let mainTop = document.getElementById('main').offsetTop;

			window.addEventListener('scroll', () => {
				let y = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;

				if (y >= mainTop) {
					document.body.classList.add('sticky');
				}
				else {
					document.body.classList.remove('sticky');
				}
			});
		}

		// Mega Menu click to close
		if (this.viewportWidth > 992) {
			document.addEventListener('click', (event) => {
				if (event.target.classList.value !== 'navigation-menu-item--primary-link' && event.target.classList.value !== 'navigation-menu-item--primary' && event.target.classList.value !== 'sub-navigation-item-header--link' && event.target.classList.value !== 'sub-navigation-item-link') {
					let menuItems = document.querySelectorAll('.navigation-menu-item--primary');

					menuItems.forEach((item) => {
						item.classList.remove('open');
					});
                }
			});
		}

		// Search
		const desktopSearchBtn = document.querySelectorAll('.js-desktop-search-btn');
		const mobileSearchBtn = document.querySelector('.js-mobile-search-btn');

		if (desktopSearchBtn !== null) {
			desktopSearchBtn.forEach((btn) => {
				btn.addEventListener('click', this.search);
			});
		}

		if (mobileSearchBtn !== null) {
			mobileSearchBtn.addEventListener('click', this.search);
		}

		let searchInputs = document.querySelectorAll('.js-search-input');
		if (searchInputs !== null) {
			searchInputs.forEach((search) => {
				search.addEventListener('keyup', this.searchEnterKey);
			});
		}

		// Notfication Banner
		let notificationClose = document.querySelectorAll('.js-notification-close');

		if (notificationClose !== null) {
			notificationClose.forEach((notification) => {
				let id = notification.parentNode.getAttribute('data-notification-id');

				// Check cookies
				if (this.getCookie(`notification-${id}`)) {
					notification.parentNode.remove();
					this.setOffset();
				}
				else {
					notification.parentNode.classList.add('active');

					notification.addEventListener('click', (event) => {
						document.cookie = `notification-${id}=1; path=/;`;
						notification.parentNode.remove();
						this.setOffset();
					});
                }
			});
        }
		//---/ Notification

		// Offset content
		document.addEventListener('DOMContentLoaded', () => {
			// Set offset
			this.setOffset();
		});

		// External links
		// The whitelist hostnames to ignore
		let _whitelist = [
			'ebanking.communityfirstfl.org',
			'ebranch.communityfirstfl.org',
			'www.communityfirstfl.org',
			'communityfirstfl.org',
			'm.mobilecu.org',
			'app.loanspq.com',
			'cs.loanspq.com',
			'www.mortgage.communityfirstfl.org',
			'mortgage.communityfirstfl.org',
			'info.communityfirstfl.org',
			'communityfirst.everfi-next.net',
			'communityfirstfl.balancepro.org'
		];

		// The external link disclaimer text to display to the user
		let _disclaimer = "Please be advised that you will no longer be subject to, or under the protection of, the privacy and security policies of Community First Credit Union of Florida's Website. We encourage you to read and evaluate the privacy and security policies of the site you are entering, which may be different from those of Community First Credit Union of Florida.";

		// Loop through all links on the page 
		// Add the external class if we have a url and that url is not like root
		let links = document.querySelectorAll('a');
		links.forEach((link) => {
			link.classList.remove('external');

			/* eslint-disable no-restricted-globals */
			if (location.hostname !== link.hostname && link.hostname.length) {
			/* eslint-enable no-restricted-globals */
				if (_whitelist.indexOf(link.hostname) === -1) {
					link.classList.add('external');
				}
			}
		});

		//Perform the redirect if we have click on an external link
		let externalLinks = document.querySelectorAll('a.external');
		externalLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				event.preventDefault();

				/* eslint-disable no-restricted-globals */
				if (confirm(_disclaimer)) {
				/* eslint-ensable no-restricted-globals */
					window.open(link.getAttribute('href'));
				}
			}); 
		});

		// On resize, adjust offsets
		let viewportLabel;

		if (this.viewportWidth > 992) {
			viewportLabel = 'desktop';
		}
		else {
			viewportLabel = 'mobile';
		}

		window.addEventListener('resize', (event) => {
			let resizedViewportLabel;
			if (window.innerWidth > 992) {
				resizedViewportLabel = 'desktop';
			}
			else {
				resizedViewportLabel = 'mobile';
			}

			if (viewportLabel !== resizedViewportLabel) {
				this.resetOffset();
				this.setOffset();
				viewportLabel = resizedViewportLabel;
            }
		});

		// enlarge ncua/eoh images on click
		this.footerImages.forEach((img, index) => {
			img.addEventListener('click', () => img.nextElementSibling.classList.remove('footer-programs-item-enlarged-closed'));
		});

		this.closeButtons.forEach(btn => {
			btn.addEventListener('click', () => btn.parentElement.classList.add('footer-programs-item-enlarged-closed'));
		});
	}

	resetOffset() {
		this.mainElement.style.marginTop = 0;
		this.navigation.style.top = 0;
		this.loginDropDown.style.top = 0;

		if (this.anchorNav !== null) {
			this.anchorNav.style.top = 0;
        }
    }

	setOffset() {
		let notificationAdjustment = 0;

		let offsetHeight = this.headerElement.offsetHeight.toString();

		if (document.querySelector('.notification-wrapper') !== null && this.viewportWidth < 992) {
			notificationAdjustment = 0;
		}

		if (window.innerWidth < 992) {
			this.mainElement.style.marginTop = `${offsetHeight - notificationAdjustment}px`;
			this.navigation.style.top = `${offsetHeight - notificationAdjustment}px`;
		}

		this.loginDropDown.style.top = `${offsetHeight - notificationAdjustment}px`;

		if (this.anchorNav !== null) {
			this.anchorNav.style.top = `${offsetHeight - notificationAdjustment}px`;
        }
    }

	search() {
		// Get query
		const query = this.previousElementSibling.value;

		// Redirect to search
		window.location.href = `/search?query=${query}`;
	}

	searchEnterKey({ key, target }) {
		if (key === 'Enter') {
			// Redirect to search
			window.location.href = `/search?query=${target.value}`;
        }
	}
	//---/ Search

	getCookie(name) {
		let value = `; ${document.cookie}`;
		let parts = value.split(`; ${name}=`);
		let cookie = '';

		if (parts.length === 2) {
			cookie = parts.pop().split(';').shift();
		}

		return cookie;
    }
}

export default Layout;